import { resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["src"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_3 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_searchbar = _resolveComponent("ion-searchbar")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_page_header = _resolveComponent("page-header")!
  const _component_ion_thumbnail = _resolveComponent("ion-thumbnail")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_list = _resolveComponent("ion-list")!
  const _component_ion_content = _resolveComponent("ion-content")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_page_header, {
      showCloseModal: true,
      title: `${_ctx.t('select')}${_ctx.t('Pet.breed')}${_ctx.petCategory ? ` (${_ctx.petCategory})` : ''}`,
      slotType: "toolbar"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_ion_toolbar, null, {
          default: _withCtx(() => [
            _createVNode(_component_ion_searchbar, {
              mode: "ios",
              modelValue: _ctx.searchKeyword,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchKeyword) = $event)),
              placeholder: _ctx.t('searchOrAdd'),
              onIonFocus: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isSearching = true)),
              onIonBlur: _cache[2] || (_cache[2] = ($event: any) => (_ctx.isSearching = false)),
              onKeyup: _cache[3] || (_cache[3] = _withKeys((e) => e.target.blur(), ["enter"]))
            }, null, 8, ["modelValue", "placeholder"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["title"]),
    _createVNode(_component_ion_content, null, {
      default: _withCtx(() => [
        _createVNode(_component_ion_list, null, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filterPets(_ctx.pets), (pet) => {
              return (_openBlock(), _createBlock(_component_ion_item, {
                key: pet.breed,
                onClick: ($event: any) => (_ctx.closeModal(`${pet.breed} ${pet.breedEn}`)),
                button: "",
                detail: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_thumbnail, { slot: "start" }, {
                    default: _withCtx(() => [
                      _createElementVNode("img", {
                        style: {"object-fit":"contain"},
                        src: pet.photoLink
                      }, null, 8, _hoisted_1)
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                    default: _withCtx(() => [
                      _createElementVNode("h2", null, _toDisplayString(pet.breed), 1),
                      _createElementVNode("p", null, [
                        _withDirectives(_createElementVNode("span", null, [
                          _createTextVNode(_toDisplayString(pet.alias), 1),
                          _hoisted_2
                        ], 512), [
                          [_vShow, pet.alias]
                        ]),
                        _withDirectives(_createElementVNode("span", null, _toDisplayString(pet.breedEn), 513), [
                          [_vShow, pet.breedEn]
                        ])
                      ])
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1032, ["onClick"]))
            }), 128)),
            _withDirectives(_createVNode(_component_ion_item, {
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.closeModal(_ctx.searchKeyword))),
              button: "",
              detail: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_thumbnail, { slot: "start" }, {
                  default: _withCtx(() => [
                    _createElementVNode("img", {
                      style: {"object-fit":"contain"},
                      src: require('@/assets/no_image.jpeg')
                    }, null, 8, _hoisted_3)
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_label, null, {
                  default: _withCtx(() => [
                    _createElementVNode("h2", null, _toDisplayString(_ctx.searchKeyword), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 512), [
              [_vShow, _ctx.filterPets(_ctx.pets).length == 0]
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}